export default () => import(/* webpackChunkName: 'coffee/app/agreement/common-agreement' */ './CommonAgreement');
